import { getRequestKeyCloak } from './api.service'

export async function getUserInRealm(
  realmId: string,
  userId: string,
  cancelPendingRequest = false
) {
  const endpoint = `/realms/${realmId}/users/${userId}`
  const res = await getRequestKeyCloak(endpoint, cancelPendingRequest)
  return res.data
}
// populates list of assignees for an errand, assignees must have roles=ERRANDS_ADMIN or roles=ERRANDS_EDITOR
export async function getUsersForRealm(realmId: string, cancelPendingRequest = false) {
  const endpoint = `/realms/${realmId}/users?roles=ERRANDS_ADMIN&roles=ERRANDS_EDITOR`
  const res = await getRequestKeyCloak(endpoint, cancelPendingRequest)
  return res.data
}
